import * as React from "react";
import { forwardRef, memo } from "react";
const SvgOutlinedNewWindowIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M17.7142 14.2857V17.7143C17.7142 18.9767 16.6908 20 15.4285 20H6.2857C5.02334 20 4 18.9767 4 17.7143V8.57143C4 7.30907 5.02334 6.28572 6.2857 6.28572H9.71424M13.7142 10.2857L20 4.00013M20 4.00013L14.8571 4M20 4.00013V9.14285", stroke: "#333333", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgOutlinedNewWindowIcon);
const Memo = memo(ForwardRef);
export default Memo;
